export default __webpack_public_path__ + "static/media/logo.80032a17.svg";